import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { Form, reduxForm } from 'redux-form';
import React from 'react';
import { HashLoader } from 'react-spinners';
import { InstitutionViewModel } from 'stageclip-common';

import AppModal from '../../modal/appModal';
import { SimpleModalId } from '../../../constants/modalId';
import { maxLength, required } from '../../form/formValidations';
import { AppTextField } from '../../form/appTextField';
import { AppTextAreaField } from '../../form/appTextAreaField';
import { allowedAudioExtensions, validateAudioFile } from '../utils/fileValidators';
import { AppFileField } from '../../form/appFileField';
import styles from '../ClipGeneratorPage.module.scss';

import { MusicUploadFormDataProps, MusicUploadFormOnSubmitProps, MusicUploadFormOwnProps } from './music.types';
import { AppSelectField } from 'components/form/appSelectField';

const generateInstitutesOptions = (institutes: InstitutionViewModel[]) =>
  institutes.map(institute => ({
    value: institute.id,
    label: institute.name,
  }));

const MusicUploadForm = ({
  form,
  handleSubmit,
  onUpload,
  isLoading,
  institutes,
  institutesLoading,
}: MusicUploadFormOwnProps) => {
  const handleOnSubmit = (values: MusicUploadFormDataProps) => onUpload(values);
  const instituteOptions = generateInstitutesOptions(institutes);

  return (
    <AppModal
      form={form}
      id={SimpleModalId.AddMusicModal}
      title="Add music"
      buttonIcon={faArrowUp}
      hideActionButtons={isLoading}
      className={styles.modal}
    >
      <Form id={form} onSubmit={handleSubmit(handleOnSubmit)}>
        {!isLoading && !institutesLoading ? (
          <>
            <AppTextField name="name" label="Music name" validate={[required, maxLength(100)]} />
            <AppTextAreaField name="description" label="Description" validate={maxLength(1000)} />
            <AppFileField
              name="musicFile"
              label="Music file"
              extensions={allowedAudioExtensions}
              validate={[required, validateAudioFile]}
            />
            <AppSelectField name="institutionId" key="institutionId" label="Institution" options={instituteOptions} />
          </>
        ) : (
          <div className={styles.loader}>
            <HashLoader />
          </div>
        )}
      </Form>
    </AppModal>
  );
};

export const MusicUploadFormContainer = reduxForm<MusicUploadFormDataProps, MusicUploadFormOnSubmitProps>({
  form: 'musicUploadForm',
  enableReinitialize: true,
})(MusicUploadForm);
